import MonthColumnChart from './MonthColumnChart';

export default MonthColumnChart;
